import { useContext, useState } from 'react';
import { DashboardContext } from '../DashboardContext';
import { useAppThunkDispatch } from '../../../state/store';
import { useSelector } from 'react-redux';
import {
  addCardsLocal,
  cardSelectors,
} from '../../../state/normalized/dashboard/cardSlice';
import CardTypesSidePanel from '../CardTypesSidePanel/CardTypesSidePanel';
import { Button } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

export const AddInsightsButton = (
  props: { style: 'header' | 'body' } = { style: `header` }
) => {
  const { style } = props;

  const { dashboardId } = useContext(DashboardContext);
  const dispatch = useAppThunkDispatch();

  const existingCardTypeIds = useSelector(
    cardSelectors.selectWorkingCardsForDashboard(dashboardId)
  ).map((card) => card.cardTypeId);

  const [isCardTypePanelOpen, setIsCardTypePanelOpen] = useState(false);

  const buttonProps =
    style === 'header'
      ? { variant: 'tertiary', size: 'small', iconName: 'add-circle-outline' }
      : {
          className: 'mt-2 mx-auto',
        };

  return (
    <>
      <CardTypesSidePanel
        open={isCardTypePanelOpen}
        handleAddCardTypes={(selectedCardTypes) => {
          // Only integrate add action
          dispatch(
            addCardsLocal({
              dashboardId,
              cardTypes: selectedCardTypes,
            })
          );
        }}
        cardTypeIdsRenderedOnDashboard={existingCardTypeIds}
        handleClose={() => setIsCardTypePanelOpen(false)}
      />
      <Button
        className={buttonProps.className}
        variant={buttonProps.variant}
        size={buttonProps.size}
        iconName={buttonProps.iconName}
        onClick={() => {
          setIsCardTypePanelOpen(true);
          // TODO: Maybe it's worth it to load card types again here, or only here
          // fetchCardTypesAndOpenSidePanel();
        }}
      >
        {intl.get('DASHBOARD_DETAIL_PAGE.ADD_INSIGHTS')}
      </Button>
    </>
  );
};
